import './polyfills.js';

const Accordion = (() => {

  const DOM = {};

  const cacheDOM = () => {
    DOM.head = document.querySelectorAll('.accordion__column__accordion__header');
    DOM.body = document.querySelectorAll('.accordion__column__accordion__content');
    DOM.cross = document.querySelectorAll('.cross-container');
    DOM.link = document.querySelectorAll('.accordion-link');
  };

  const onLoad = () => {
    window.addEventListener('load', function () {
      Array.from(DOM.body).forEach((element) => {
        element.classList.add('accordion-closed');
        element.setAttribute('style', `height: 0`);
      });
    })
  };

  const eventListener = () => {
    Array.from(DOM.head).forEach((element) => {
      element.addEventListener('click', toggleAccordion);
    });
  };

  function toggleAccordion(event) {
    event.preventDefault();
    const head = event.currentTarget;
    const body = head.nextElementSibling;
    const link = body.getElementsByClassName('accordion-link');
    if (body.classList.contains('accordion-open')) {
      body.classList.add('accordion-closed');
      body.classList.remove('accordion-open');
      body.setAttribute('style', `height: 0`);
      head.classList.remove('header-clicked');
      head.setAttribute('aria-expanded', 'false');
      for(let i = 0; i < link.length; i++ ) {
        link[i].setAttribute('tabindex', '-1');
      }
    } else {
      Array.from(DOM.body).forEach(element => {
        element.classList.add('accordion-closed');
        element.classList.remove('accordion-open');
        element.setAttribute('style', `height: 0`);
      });
      Array.from(DOM.head).forEach(element => {
        element.classList.remove('header-clicked');
        element.setAttribute('aria-expanded', 'false');
      });
      Array.from(DOM.link).forEach(element => {
        element.setAttribute('tabindex', '-1');
      });
      body.classList.remove('accordion-closed');
      body.classList.add('accordion-open');
      body.setAttribute('style', `height: ${body.scrollHeight}px`);
      head.classList.add('header-clicked');
      head.setAttribute('aria-expanded', 'true');
      for(let i = 0; i < link.length; i++ ) {
        link[i].setAttribute('tabindex', '0');
      }
    }
  }

  const init = () => {
    cacheDOM();
    onLoad();
    eventListener();

  };

  return {
    init

  }
})();

export default Accordion;
